import BaseAPIService from '@/services/baseAPIService'

export default class InventoryAPIService extends BaseAPIService {
  constructor(httpClient, reportingHttpClient) {
    super(httpClient, reportingHttpClient)
  }

  // Stock
  getStock(id)                      { return this.httpClient.get(`/inventory/stock/${id}`) }
  createStock(data)                 { return this.httpClient.post(`/inventory/stock`, data) }
  updateStock(id, data)             { return this.httpClient.put(`/inventory/stock/${id}`, data) }
  updateStockPricing(id, data)      { return this.httpClient.put(`/inventory/stock/${id}/pricing`, data) }
  getStockList(options = {}, filter = {}) {
    var params = {
      filter: filter || {},
      include: options.include
    }

    var queryString = '/inventory/stock?' + $.param(params)
    return this.httpClient.get(queryString)
  }
  getStockFilteredList(searchString, stockType, length) {
    var queryString = `/inventory/stock?search[value]=${encodeURIComponent(searchString)}`
    if(length > 0)
      queryString += `&length=${encodeURIComponent(length)}`
    if(stockType != '' && stockType != null)
      queryString += `&filter[type]=${encodeURIComponent(stockType)}`

    return this.httpClient.get(queryString)
  }
  archiveStock(id)                { return this.httpClient.put(`/inventory/stock/${id}/archive`) }
  restoreStock(id)                { return this.httpClient.put(`/inventory/stock/${id}/restore`) }

  // Stock Category
  getStockCategoryList()           { return this.httpClient.get(`/inventory/stockcategory`) }
  createStockCategory(data)        { return this.httpClient.post(`/inventory/stockcategory`, data) }
  updateStockCategory(id, data)    { return this.httpClient.put(`/inventory/stockcategory/${id}`, data) }
  updateStockCategoryBatch(listData)  { return this.httpClient.put(`/inventory/stockcategory`, listData) }

  // Stock Price Group
  getStockPriceGroupList()           { return this.httpClient.get(`/inventory/stockpricegroup`) }
  createStockPriceGroup(data)        { return this.httpClient.post(`/inventory/stockpricegroup`, data) }
  updateStockPriceGroup(id, data)    { return this.httpClient.put(`/inventory/stockpricegroup/${id}`, data) }
  updateStockPriceGroupBatch(listData) { return this.httpClient.put(`/inventory/stockpricegroup`, listData) }

  // Stock Sales Price Group
  getStockSalesPriceGroupList()         { return this.httpClient.get(`/inventory/stocksalespricegroup`) }
  createStockSalesPriceGroup(data)      { return this.httpClient.post(`/inventory/stocksalespricegroup`, data) }
  updateStockSalesPriceGroup(id, data)  { return this.httpClient.put(`/inventory/stocksalespricegroup/${id}`, data) }

  // Service Price Range / Group
  getServicePriceRangeList()             { return this.httpClient.get(`/inventory/servicepricerange`) }
  createServicePriceRange(data)          { return this.httpClient.post(`/inventory/servicepricerange`, data) }
  updateServicePriceRange(id, data)      { return this.httpClient.put(`/inventory/servicepricerange/${id}`, data) }

  // Stock Container
  getStockContainerList()           { return this.cachedGet(`/inventory/stockcontainer`) }
  createStockContainer(data)        { return this.httpClient.post(`/inventory/stockcontainer`, data) }
  updateStockContainer(id, data)    { return this.httpClient.put(`/inventory/stockcontainer/${id}`, data) }
  updateStockContainerBatch(listData)  { return this.httpClient.put(`/inventory/stockcontainer`, listData) }

  // Inventory Bins
  getInventoryBinList(params = {}) {
    return this.cachedGet(`/inventory/bins?` + $.param(params))
  }
  getInventoryBin(id)               { return this.httpClient.get(`/inventory/bins/${id}`) }
  createInventoryBin(data)          { return this.httpClient.post(`/inventory/bins`, data) }
  createInventoryBinBatch(data)     { return this.httpClient.post(`/inventory/bins/batch`, data) }
  updateInventoryBin(id, data)      { return this.httpClient.put(`/inventory/bins/${id}`, data) }
  getInventoryBinContents(id, params = {}) {
    return this.httpClient.get(`/inventory/bins/${id}/contents?` + $.param(params))
  }

  generatePrintInventoryBinLabelURL(inventoryBinId, params = {}) {
    var exportURL = `/inventory/bins/${inventoryBinId}/label?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }
  generatePrintInventoryBinLabelListURL(inventoryBinIdList, params = {}) {
    params.binIdList = inventoryBinIdList
    var exportURL = `/inventory/bins/labels?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }

  // Glass Size
  getGlassSizeList()                       { return this.httpClient.get(`/inventory/glasssizes`) }

  // Stock - Glass Size
  getGlassSize(stockId, id)                { return this.httpClient.get(`/inventory/stock/${stockId}/glasssize/${id}`) }
  createGlassSize(stockId, data)           { return this.httpClient.post(`/inventory/stock/${stockId}/glasssize`, data) }
  updateGlassSize(stockId, id, data)       { return this.httpClient.put(`/inventory/stock/${stockId}/glasssize/${id}`, data) }
  getGlassSizeMovingAvg(stockId, glassSizeId, params = {}) {
    var queryString = `/inventory/stock/${stockId}/glasssize/${glassSizeId}/movingaverage?` + $.param(params)
    
    return this.httpClient.get(queryString)
  }
  adjustGlassSizeMovingAvg(stockId, id, data) { return this.httpClient.post(`/inventory/stock/${stockId}/glasssize/${id}/adjustmovingaverage`, data) }

  // Glass Level
  getGlassLevelList()                      { return this.httpClient.get(`/inventory/glasslevels`) }
  getGlassLevel(id)                        { return this.httpClient.get(`/inventory/glasslevels/${id}`) }

  generatePrintOffcutLabelURL(glassLevelId, params = {}) {
    var exportURL = `/inventory/glasslevels/${glassLevelId}/label?` + $.param(params)
    return this.httpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }

  // Glass Blocks
  getGlassBlock(id)                       { return this.httpClient.get(`/inventory/glassblocks/${id}`) }
  createGlassBlock(data)                  { return this.httpClient.post(`/inventory/glassblocks`, data) }
  updateGlassBlock(id, data)              { return this.httpClient.put(`/inventory/glassblocks/${id}`, data) }
  getGlassBlockList(filter = {}) {
    var params = {
      filter: filter
    }   
    var queryString = '/inventory/glassblocks?' + $.param(params)
    return this.httpClient.get(queryString)
  }
  openGlassBlock(id)                       { return this.httpClient.post(`/inventory/glassblocks/${id}/open`) }
  closeGlassBlock(id)                      { return this.httpClient.post(`/inventory/glassblocks/${id}/close`) }

  generatePrintBlockLabelURL(glassBlockId, params = {}) {
    var exportURL = `/inventory/glassblocks/${glassBlockId}/label?` + $.param(params)
    return this.reportingHttpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }
  generatePrintBlockLabelListURL(glassBlockIdList, params = {}) {
    params.glassBlockIdList = glassBlockIdList
    var exportURL = `/inventory/glassblocks/labels?` + $.param(params)
    return this.reportingHttpClient.post(`/system/signedurl`, { path: `api/v1${exportURL}` })
  }

  // Stock Transactions
  createStockAdjustment(data)           { return this.httpClient.post(`/inventory/adjustment`, data) }

  // Stocktake
  getStockTakeFilteredList(options = {}) {
    var params = {
      filter: {}
    }   
    var queryString = '/inventory/stocktakes?' + $.param(params)
    return this.httpClient.get(queryString)
  }
  getStockTake(id)                { return this.httpClient.get(`/inventory/stocktakes/${id}`) }
  createStocktake(data)           { return this.httpClient.post(`/inventory/stocktakes`, data) }
  updateStocktake(id, data)       { return this.httpClient.put(`/inventory/stocktakes/${id}`, data) }

  // Stocktake - Stock
  getStockTakeStockList(stockTakeId)                       { return this.httpClient.get(`/inventory/stocktakes/${stockTakeId}/stock`) }
  runStockTakeStockBarcodeLookup(stockTakeId, barcode)     { return this.httpClient.get(`/inventory/stocktakes/${stockTakeId}/barcode/lookup?barcode=${encodeURIComponent(barcode)}`) }
  updateStockTakeToCounting(stockTakeId)                   { return this.httpClient.post(`/inventory/stocktakes/${stockTakeId}/counting`) }
  updateStockTakeToReview(stockTakeId)                     { return this.httpClient.post(`/inventory/stocktakes/${stockTakeId}/review`) }
  updateStockTakeToRecount(stockTakeId, data)              { return this.httpClient.post(`/inventory/stocktakes/${stockTakeId}/recount`, data) }
  completeStockTake(stockTakeId)                           { return this.httpClient.post(`/inventory/stocktakes/${stockTakeId}/complete`) }
  cancelStockTake(stockTakeId)                             { return this.httpClient.post(`/inventory/stocktakes/${stockTakeId}/cancel`) }
  updateStockTakeItems(stockTakeId, data)                  { return this.httpClient.put(`/inventory/stocktakes/${stockTakeId}/items`, data) }
  getStockTakeItemList(stockTakeId, options = {}) {
    var params = {
      filter: {}
    }
    if(options.isRecount)
      params.filter.isRecount = options.isRecount

    var queryString = `/inventory/stocktakes/${stockTakeId}/items?` + $.param(params)
    return this.httpClient.get(queryString)
  }
  getStockTakeItem(stockTakeId, id)                        { return this.httpClient.get(`/inventory/stocktakes/${stockTakeId}/items/${id}`) }
  updateStockTakeItemCountBatch(stockTakeId, data)         { return this.httpClient.put(`/inventory/stocktakes/${stockTakeId}/itemcounts/batch`, data) }

  // Inventory - Config Settings
  getConfigSettings()               { return this.httpClient.get(`/inventory/config/settings`) }
  updateConfigSettings(data)        { return this.httpClient.put(`/inventory/config/settings`, data) }
}
